<template>
  <div
    class="ui-select-badge"
    :class="{clear: isHoverClose}"
  >
    <div class="ui-select-badge__text">
      <slot>
        {{ title }}
      </slot>
    </div>
    <div
      v-if="!disabled"
      class="ui-select-badge__close"
      @click.stop="$emit('close')"
      @mouseover="isHoverClose = true"
      @mouseleave="isHoverClose = false"
    >
      <ui-icon
        class="ui-select-badge__close--icon"
        name="close"
      />
    </div>
  </div>
</template>

<script>
import UiIcon from '../icons/UiIcon.vue'

export default {
  components: {
    UiIcon
  },
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isHoverClose: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-select-badge {
  @include font-14;
  display: flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: $border-radius-01;
  background-color: $blue-4;
  transition: opacity .1s, background-color .1s;

  &.clear {
    opacity: .5;
  }

  &__text {
    @include ellipsis;
  }

  &__close {
    @include flex-center;
    height: 10px;
    width: 10px;
    margin-left: 10px;
    cursor: pointer;

    &--icon {
      height: 8px;
      width: 8px;
      fill: $black-02;
      transition: fill .1s;
    }
  }
}

</style>
